import React from "react";
import { IconType } from "react-icons";

import styles from "./EmptyState.module.scss";

interface Props {
  icon: IconType;
  title: string;
  description?: string;
}

export const EmptyState: React.FC<Props> = ({
  icon: Icon,
  title,
  description,
}) => {
  return (
    <div className={styles.Container}>
      <div className={styles.IconWrap} aria-hidden="true">
        <Icon className={styles.BgIcon} />
      </div>

      <div className={styles.Content}>
        <h3 className={styles.Title}>{title}</h3>
        {description && <p className={styles.Description}>{description}</p>}
      </div>
    </div>
  );
};